import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useEyeconxStore } from '../../../store/eyeconxStore';
import bookingService from '../../../services/booking.service';
import { showError, showSuccess } from '../../../utils/ecxSwal';

function NotesModal({ patientBooking, show, onClose, handleUpdate }) {
    const clinicId = useEyeconxStore((state) => state.user?.clinicId);

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting },
    } = useForm({
        defaultValues: { clinicComments: '' },
    });

    useEffect(() => {
        if (patientBooking && show) {
            reset({
                clinicComments: patientBooking.clinicComments || '',
            });
        }
    }, [patientBooking, show, reset]);

    const onSubmitComments = async (data) => {
        const updatedRequest = {
            ...patientBooking,
            clinicId,
            clinicComments: data.clinicComments || '',
        };

        try {
            await bookingService.updateBookingRequests(clinicId, updatedRequest);
            showSuccess({ title: 'Notes Saved', text: 'Clinic notes were updated successfully.' });
            handleUpdate?.();
            onClose();
        } catch (error) {
            console.error('Error updating booking:', error);
            showError({ title: 'Save Failed', text: 'Failed to save clinic notes.' });
        }
    };

    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            size="lg"
            className="web-bookings-notes-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="bi bi-journal-text me-2"></i>
                    Add Clinic Notes
                </Modal.Title>
            </Modal.Header>

            <form onSubmit={handleSubmit(onSubmitComments)}>
                <Modal.Body>
                    <div className="mb-3">
                        <h6 className="fw-semibold text-dark mb-1">
                            {patientBooking?.firstName} {patientBooking?.lastName}
                        </h6>
                        <p className="text-muted small mb-0">{patientBooking?.doctorName}</p>
                    </div>

                    <div className="mb-0">
                        <label htmlFor="clinicComments" className="form-label fw-semibold">
                            Clinic Notes / Comments
                        </label>
                        <textarea
                            id="clinicComments"
                            className={`form-control ${errors.clinicComments ? 'is-invalid' : ''}`}
                            rows="5"
                            {...register('clinicComments', {
                                required: 'Please enter a comment or note',
                                maxLength: {
                                    value: 500,
                                    message: 'Comments cannot exceed 500 characters',
                                },
                            })}
                            placeholder="Add internal notes or comments about this booking request..."
                        ></textarea>
                        {errors.clinicComments && (
                            <div className="invalid-feedback">{errors.clinicComments.message}</div>
                        )}
                        <div className="form-text">These notes are visible only to clinic staff.</div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary rounded-pill ecx-modal__close-btn"
                        onClick={onClose}
                        disabled={isSubmitting}
                    >
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-sm btn-accent rounded-pill" disabled={isSubmitting}>
                        <i className="bi bi-save me-1"></i>
                        Save Notes
                    </button>
                </Modal.Footer>
            </form>
        </Modal>
    );
}

export default NotesModal;
